import r from "./internal/_checkForMethod.mjs";
import t from "./internal/_curry1.mjs";
import o from "./slice.mjs";
var i = /* @__PURE__ */ t(
  /* @__PURE__ */ r(
    "tail",
    /* @__PURE__ */ o(1, 1 / 0)
  )
);
const e = i;
export {
  e as default
};
